module.exports = __webpack_public_path__ + "e6c98413660ee1f0c9d1069fad3be956.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_neutral.svg
// module id = 982
// module chunks = 0